import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import { CiEdit } from "react-icons/ci";
import { MdDelete, MdDragIndicator } from "react-icons/md";
import './firmalar.css'
import { toast } from "react-toastify";
import { nodeURL } from "../configUrl";
import { FaCircleMinus } from "react-icons/fa6";
import { CiSquareChevLeft } from "react-icons/ci";
import { useNavigate } from 'react-router-dom';
import { CiTrash } from "react-icons/ci";
import Swal from 'sweetalert2';
import SearchableSelect from "./SearchableSelect";
import { findSimilarMatch, normalizeName } from "../utils/similarity";

const TeklifFormuOlustur = () => {
    const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState(""); // Arama inputu
  const [firms, setFirms] = useState([]);
  const [kiralamalar, setKiralamalar] = useState([]);
  const [showForm, setShowForm] = useState(null); // "add" veya firma ID (edit) olabilir
  const [teklifler, setTeklifler] = useState([]); 
  const [formData, setFormData] = useState({ name: "", email: "" });
  const [selectedFirm, setSelectedFirm] = useState('');
  const [selectedTeklif, setSelectedTeklif] = useState('');
  const [selectedFirmLabel, setSelectedFirmLabel] = useState('');
  const [selectedİlgili, setSelectedFirmİlgili] = useState('');
  const [aciklama, setAciklama] = useState(
    `• Dikey ve yatay taşıma kiracıya aittir.\n• Periyodik muayene, söküm ve dönüş nakliyesi opsiyoneldir.`
  );
  const [projename, setProjeName] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [page, setPage] = useState(1);
  const [unitPrice, setUnitPrice] = useState(0);
  const [birim, setBirim] = useState(  { value: "1", label: "₺" });
  const [productList, setProductList] = useState([]);
  const [urunler, setUrunler] = useState([]);
  const [loading, setLoading] = useState(false); 
console.log(productList,"productlistt");
const [isEdit, setIsEdit] = useState(false);
const [teklifId, setTeklifId] = useState(null);
const [isEditProduct, setIsEditProduct] = useState(false);
const [editProductIndex, setEditProductIndex] = useState(null);
const [dragProductIndex, setDragProductIndex] = useState(null);
const [dragOverProductIndex, setDragOverProductIndex] = useState(null);
  const [secilenTeklif, setSecilenTeklif] = useState(null);
  const [selectedTeklifTuru, setSelectedTeklifTuru] = useState("asma");
  const [loadingSozlesmeId, setLoadingSozlesmeId] = useState(null);

  const [baslangicTarihi, setBaslangicTarihi] = useState(() => {
    const today = new Date().toISOString().split("T")[0];
    return today;
  });

  const [urunCinsleri, setUrunCinsleri] = useState([]);
  const [araToplamOverride, setAraToplamOverride] = useState(null);

  const [showFirmaModal, setShowFirmaModal] = useState(false);
  const [yeniFirma, setYeniFirma] = useState({ name: "", ilgili_kisi: "", phone: "", email: "" });
  const [savingFirma, setSavingFirma] = useState(false);

  const [showUrunModal, setShowUrunModal] = useState(false);
  const [yeniUrun, setYeniUrun] = useState({ adi: "", cinsi_id: "", stok_adet: 0 });
  const [savingUrun, setSavingUrun] = useState(false);

  const [showSozlesmeModal, setShowSozlesmeModal] = useState(false);
  const [sozlesmeTeklif, setSozlesmeTeklif] = useState(null);
  const [kaseForm, setKaseForm] = useState({ firmaAdi: "", adres: "", vergiDairesi: "", vergiNo: "" });

  // 📌 Teklif detayı getir

  // const handleDetay = (teklif) => {
  //   console.log(teklifler,"tekliflerrrrr");
    
  //   navigate("/home/kiradakiurunler", { state: { teklifler:teklifler } });
  // };

  const handleEditProduct = (product,index) => {
    // Eğer product bir dizi geldiyse ilk elemanı al
    const p = Array.isArray(product) ? product[0] : product;

    setIsEditProduct(true);
    setEditProductIndex(index);
  
    if (!p) return;
  
    console.log(p, "producttt");
  
    setSelectedProduct({
      value: p.urun_id,
      label: p.urun_adi,
      cinsi_id: p.urun_cinsi_id,
    });
  
    setQuantity(p.adet);
    setUnitPrice(p.birim_fiyat);
    setAciklama(p.aciklama);
    setUnitPrice(Number(p.birim_fiyati))
  
    setBirim({
      value: p.birim_id || p.birim || 1,
      label: p.birim || "₺",
    });
  
    // setEditIndex(index);
  };
  const handleDetay = async (id) => {
    setLoading(true);
    try {
      const res = await axios.get(`${nodeURL}/getTeklifler/${id}`);
      setSecilenTeklif(res.data);
      console.log(res.data,"secişentelkligfff");
      navigate("/home/kiradakiurunler/yeni", { state: { teklifler:res.data } });
      
    } catch (err) {
      console.error("Detay alınamadı:", err);
    } finally {
      setLoading(false);
    }
  };
  const handleTeklifDuzenle = async (id) => {
    setLoading(true);
    setPage(2);
  
    try {
      const res = await axios.get(`${nodeURL}/getTeklifler/${id}`);
      const teklif = res.data;
  
      // 🔹 TEKLİF BİLGİLERİ
      setIsEdit(true);
      setTeklifId(teklif.id);
  
      setSelectedFirm(teklif.firma_id);
      setSelectedFirmLabel(teklif.firma_adi); // varsa
      setProjeName(teklif.proje_ismi || "");
      setAciklama(teklif.aciklama || "");
      setKdvOrani(Number(teklif.kdv_orani));
      
  
      // 🔹 ÜRÜNLER (array!)
      const formattedProducts = teklif.urunler.map(u => ({
        id: u.id,
        urun_id: u.urun_id,
        urun_adi: u.urun_adi,
        urun_cinsi_id: u.urun_cinsi_id,
        adet: Number(u.adet),
        birim_fiyati: Number(u.birim_fiyati),
        toplam: Number(u.toplam)
      }));
  
      setProductList(formattedProducts);
  
    
  
    } catch (err) {
      console.error("Teklif detayı alınamadı:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (id) => {

    Swal.fire({
      title: 'Emin misiniz?',
      text: 'Seçilen Teklif silinecek!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Evet',
      cancelButtonText: 'Vazgeç',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
        .delete(`${nodeURL}/deleteTeklif/${id}`)
        .then((response) => {
          console.log("TEKLİF silindi:", response.data);
       getInfos();
        })
        .catch((error) =>{
          console.error("TEKLİF Hatası:", error.response?.data || error.message)
          toast.error("TEKLİF Silinirken hata oluştu!", { position: "top-right" });
     } );
      }
    });

 
  };
  const [kdvOrani, setKdvOrani] = useState(20);
  
  const birimler = [
    { value: "1", label: "₺" },
    { value: "2", label: "$" },
    { value: "3", label: "€" }
  ];

  console.log(secilenTeklif,"secişentelkligfff");

  const handleAddForm = () => {
    setFormData({ name: "", email: "" });
    setPage(2);
  };

  const onChangeBirim = (e) => {

    
    const selectedBirim = birimler.find(b => b.value === e.target.value);
    setBirim(selectedBirim || { value: "", label: "" });
  };
  const araToplamCalculated = productList.reduce((acc, item) => {
    const birimFiyat = parseFloat(item.birim_fiyat || item.birim_fiyati || 0);
    const adet = parseFloat(item.adet || 0);
    const toplam = parseFloat(item.toplam || birimFiyat * adet);
    return acc + toplam;
  }, 0);
  const araToplam = araToplamOverride ?? araToplamCalculated;

  const kdvTutar = (araToplam * (kdvOrani || 0)) / 100;
  const genelToplam = araToplam + kdvTutar;

  const formatBirimFiyat = (value) => (Number(value) ? `${value} ₺` : "-");

  const sanitizeForFilename = (name) =>
    (name || "teklif")
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
      .replace(/[^a-zA-Z0-9_-]+/g, "_");

  const downloadPdfBlob = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.open(url);
  };

  const handlePdf = async () => {
    if (!selectedFirmLabel) {
      toast.error("Lütfen Bir Firma Seçiniz!", { position: "top-right" });
      return;
    }

    // araToplam/kdvTutar/genelToplam üst kapsamdan geliyor (elle değiştirilmişse onu yansıtır)
    const data = {
      firmaAdi: selectedFirmLabel,
      proje: "-",
      ilgili: selectedİlgili,
      iletisim: "+90 544 644 74 52",
      temsilci: "Oğuz Kırbayır",
      urunler: productList,
      araToplam,
      proje_ismi: projename,
      kdvOrani,
      kdvTutar,
      genelToplam,
      aciklama:aciklama,
      birim:birim.label,
      teklifTuru:selectedTeklifTuru
    };
  
    setLoading(true); // ✅ Yükleme başlar
  
    try {
      const response = await axios.post(`${nodeURL}/teklifPdf`, data, {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/pdf",
        },
      });
  
      const blob = new Blob([response.data], { type: "application/pdf" });
      downloadPdfBlob(blob, `${sanitizeForFilename(selectedFirmLabel)}_Teklif.pdf`);

    } catch (error) {
      console.error("PDF oluşturulamadı:", error);
  
      if (error.response?.data) {
        const blob = new Blob([error.response.data], { type: "text/plain" });
        const reader = new FileReader();
        reader.onload = () => console.error("Hata içeriği:", reader.result);
        reader.readAsText(blob);
      }
    } finally {
      setLoading(false); // ✅ Yükleme biter
    }
  };

  const openSozlesmeModal = (teklif) => {
    setSozlesmeTeklif(teklif);
    setKaseForm({
      firmaAdi: teklif?.firma_adi || "",
      adres: "",
      vergiDairesi: "",
      vergiNo: "",
    });
    setShowSozlesmeModal(true);
  };

  const handleSozlesmeModalSubmit = () => {
    if (!sozlesmeTeklif) return;
    setShowSozlesmeModal(false);
    handleSozlesmePdf(sozlesmeTeklif.id, kaseForm);
  };

  const handleSozlesmePdf = async (id, kase) => {
    setLoadingSozlesmeId(id);
    try {
      const response = await axios.post(
        `${nodeURL}/sozlesmePdf`,
        {
          teklifId: id,
          kaseFirmaAdi: kase?.firmaAdi,
          kaseAdres: kase?.adres,
          kaseVergiDairesi: kase?.vergiDairesi,
          kaseVergiNo: kase?.vergiNo,
        },
        {
          responseType: "arraybuffer",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/pdf",
          },
        }
      );
      const blob = new Blob([response.data], { type: "application/pdf" });
      const firmaAdi = kase?.firmaAdi || sozlesmeTeklif?.firma_adi || "sozlesme";
      downloadPdfBlob(blob, `${sanitizeForFilename(firmaAdi)}_Sozlesme.pdf`);
    } catch (error) {
      console.error("Sözleşme PDF oluşturulamadı:", error);
      toast.error("Sözleşme oluşturulamadı!", { position: "top-right" });
    } finally {
      setLoadingSozlesmeId(null);
    }
  };
  const handleSave = async () => {
    if (!selectedFirmLabel) {
      toast.error("Lütfen Bir Firma Seçiniz!", { position: "top-right" });
      return;
    }

    // araToplam/kdvTutar/genelToplam üst kapsamdan geliyor (elle değiştirilmişse onu yansıtır)
    const data = {
      firma_id: selectedFirm,
      proje: "-",
      ilgili: selectedİlgili,
      iletisim: "+90 544 644 74 52",
      temsilci: "Oğuz Kırbayır",
      urunler: productList,
      araToplam,
      proje_ismi: projename,
      kdvOrani,
      kdvTutar,
      genelToplam,
      aciklama
    };
  
    try {
      await axios.post(`${nodeURL}/teklifKaydet`, data);
      toast.success("Teklif başarıyla kaydedildi!", { position: "top-right" });
      getInfos();
      setPage(1);
    } catch (error) {
      console.error("Teklif kaydedilemedi:", error);
      toast.error("Teklif kaydedilemedi!", { position: "top-right" });
    }
  };


  const handleAddProduct = () => {

    const newProduct = {
      firma_id: selectedFirm,
      urun_id: selectedProduct.value,
      urun_adi: selectedProduct.label,
      proje_ismi: projename,
      urun_cinsi_id: selectedProduct.cinsi_id,
      adet: quantity,
      birim_fiyati: unitPrice,
      toplam: quantity * unitPrice,
      birim: birim.label,
      aciklama: aciklama
    };
  
    console.log(newProduct, "newproduct");
  
    if (isEditProduct && editProductIndex !== null) {
      // ✏️ GÜNCELLE
      const updatedList = [...productList];
      updatedList[editProductIndex] = newProduct;
      setProductList(updatedList);

      // edit modundan çık
      setIsEditProduct(false);
      setEditProductIndex(null);

    } else {
      // ➕ YENİ EKLE
      setProductList(prev => [...prev, newProduct]);
    }
    setAraToplamOverride(null); // ürün listesi değişti, otomatik toplama dön

    // 🔄 Formu sıfırla
    setSelectedProduct('');
    setQuantity(1);
    setUnitPrice(0);
    setAciklama('');
  };

  const handleDeleteList = (index) => {

    Swal.fire({
      title: "Emin misiniz?",
      text: "Bu ürünü silmek istediğinize emin misiniz?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Evet, sil",
      cancelButtonText: "Vazgeç"
    }).then((result) => {
      if (result.isConfirmed) {
     // Edit edilen ürün siliniyorsa edit modundan çık
     if (isEditProduct && editProductIndex === index) {
      setIsEditProduct(false);
      setEditProductIndex(null);
  
      setSelectedProduct('');
      setQuantity(1);
      setUnitPrice(0);
      setAciklama('');
    }
  
    setProductList(prev => prev.filter((_, i) => i !== index));
    setAraToplamOverride(null); // ürün listesi değişti, otomatik toplama dön
      }
    });


  };

  const handleProductDragStart = (index) => (e) => {
    setDragProductIndex(index);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleProductDragOver = (index) => (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    if (index !== dragOverProductIndex) setDragOverProductIndex(index);
  };

  const handleProductDrop = (index) => (e) => {
    e.preventDefault();
    const from = dragProductIndex;
    const to = index;
    setDragProductIndex(null);
    setDragOverProductIndex(null);
    if (from === null || from === to) return;

    setProductList((prev) => {
      const updated = [...prev];
      const [moved] = updated.splice(from, 1);
      updated.splice(to, 0, moved);
      return updated;
    });

    // Düzenlenmekte olan satır taşındıysa index'ini yeni konumuna göre güncelle
    if (isEditProduct && editProductIndex !== null) {
      setEditProductIndex((prevIndex) => {
        if (prevIndex === from) return to;
        if (from < prevIndex && to >= prevIndex) return prevIndex - 1;
        if (from > prevIndex && to <= prevIndex) return prevIndex + 1;
        return prevIndex;
      });
    }
  };

  const handleProductDragEnd = () => {
    setDragProductIndex(null);
    setDragOverProductIndex(null);
  };

  const getInfos = async () => {
    setLoading(true); 
    try {
      await axios.get(`${nodeURL}/getKiralamalar`)
      .then((response) => {
        setKiralamalar(response.data);
        console.log(response.data,"getkiralamaaaaa");
        
      })
      .catch((error) => {
        toast.error("Kiralama yüklenirken hata oluştu!", { position: "top-right" });
      });


   await axios.get(`${nodeURL}/getFirmalar`)
      .then((response) => {
        setFirms(response.data);
        console.log(response.data,"firms");
        
      })
      .catch((error) => {
        toast.error("Firmalar yüklenirken hata oluştu!", { position: "top-right" });
      });

    await  axios
      .get(`${nodeURL}/getUrunler`)
      .then((response) => {
        console.log("Gelen urunler:", response.data);
        setUrunler(response.data);
      })
      .catch((error) => {
        toast.error("Ürünler yüklenirken hata oluştu!", { position: "top-right" });
      });

    await axios
      .get(`${nodeURL}/getUrunCinsleri`)
      .then((response) => {
        setUrunCinsleri(response.data);
      })
      .catch((error) => {
        toast.error("Ürün Cinsleri yüklenirken hata oluştu!", { position: "top-right" });
      });
    } catch {
      toast.error("Veriler yüklenirken hata oluştu!", { position: "top-right" });
    }
    finally{
      setLoading(false)
    }

 


    await  axios
      .get(`${nodeURL}/getTeklifler`)
      .then((response) => {
        console.log("Gelen teklifler:", response.data);
        setTeklifler(response.data);
      })
      .catch((error) => {
        toast.error("teklifler yüklenirken hata oluştu!", { position: "top-right" });
      });

  };

  useEffect(() => {
    getInfos();
  }, []);

  const openFirmaModal = (query) => {
    setYeniFirma({ name: query || "", ilgili_kisi: "", phone: "", email: "" });
    setShowFirmaModal(true);
  };

  const handleSaveYeniFirma = async () => {
    if (!yeniFirma.name.trim()) {
      toast.warning("Firma adı boş bırakılamaz!", { position: "top-right" });
      return;
    }

    const turkishChars = /[ığüşöçİĞÜŞÖÇ]/;
    if (turkishChars.test(yeniFirma.email)) {
      toast.error("E-posta adresinde Türkçe karakter kullanılamaz!", { position: "top-right" });
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (yeniFirma.email && !emailRegex.test(yeniFirma.email)) {
      toast.error("Geçersiz e-posta adresi!", { position: "top-right" });
      return;
    }

    const similar = findSimilarMatch(yeniFirma.name, firms, (f) => f.name);
    if (similar) {
      const confirmText =
        similar.type === "exact"
          ? `"${similar.match.name}" isminde bir firma zaten kayıtlı. Yine de eklemek istiyor musunuz?`
          : `"${similar.match.name}" isimli firmaya benzer bir isim girdiniz. Yine de eklemek istiyor musunuz?`;
      const result = await Swal.fire({
        title: "Emin misiniz?",
        text: confirmText,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Evet, ekle",
        cancelButtonText: "Vazgeç",
      });
      if (!result.isConfirmed) return;
    }

    setSavingFirma(true);
    try {
      const response = await axios.post(`${nodeURL}/createFirmalar`, yeniFirma);
      const created = response.data;
      setFirms((prev) => [...prev, created]);
      setSelectedFirm(created.id);
      setSelectedFirmLabel(created.name);
      setSelectedFirmİlgili(created.ilgili_kisi || "");
      toast.success("Firma başarıyla eklendi!", { position: "top-right" });
      setShowFirmaModal(false);
    } catch (error) {
      toast.error("Firma eklenirken hata oluştu!", { position: "top-right" });
    } finally {
      setSavingFirma(false);
    }
  };

  const openUrunModal = (query) => {
    setYeniUrun({ adi: query || "", cinsi_id: "", stok_adet: 0 });
    setShowUrunModal(true);
  };

  const handleSaveYeniUrun = async () => {
    if (!yeniUrun.adi.trim() || !yeniUrun.cinsi_id) {
      toast.warning("Ürün adı ve cinsi boş bırakılamaz!", { position: "top-right" });
      return;
    }

    const similar = findSimilarMatch(yeniUrun.adi, urunler, (u) => u.adi);
    if (similar) {
      const confirmText =
        similar.type === "exact"
          ? `"${similar.match.adi}" isminde bir ürün zaten kayıtlı. Yine de eklemek istiyor musunuz?`
          : `"${similar.match.adi}" isimli ürüne benzer bir isim girdiniz. Yine de eklemek istiyor musunuz?`;
      const result = await Swal.fire({
        title: "Emin misiniz?",
        text: confirmText,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Evet, ekle",
        cancelButtonText: "Vazgeç",
      });
      if (!result.isConfirmed) return;
    }

    setSavingUrun(true);
    try {
      const parsedStok = Number.isFinite(Number(yeniUrun.stok_adet))
        ? Math.max(0, parseInt(yeniUrun.stok_adet, 10))
        : 0;
      const payload = { ...yeniUrun, stok_adet: parsedStok };
      const response = await axios.post(`${nodeURL}/createUrunler`, payload);
      const created = response.data;
      const cinsi = urunCinsleri.find((c) => c.id == created.cinsi_id);
      const createdWithCins = { ...created, cins_adi: cinsi?.cins_adi };
      setUrunler((prev) => [...prev, createdWithCins]);
      setSelectedProduct({
        value: created.id,
        label: created.adi,
        cinsi_id: created.cinsi_id,
      });
      toast.success("Ürün başarıyla eklendi!", { position: "top-right" });
      setShowUrunModal(false);
    } catch (error) {
      toast.error("Ürün eklenirken hata oluştu!", { position: "top-right" });
    } finally {
      setSavingUrun(false);
    }
  };

  return (
    <div
      style={{
        background: "rgba(255, 255, 255, 0.2)",
        borderRadius: "15px",
        padding: "20px",
        backdropFilter: "blur(10px)",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
      }}
      className="container-fluid"
    >
      {/* Geri Dön Butonu */}

      {page == 1 ? (
<>
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
    flexWrap: "wrap",
  }}
>
  <input
    type="text"
    placeholder="Firma Ara..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    style={{
      padding: "8px",
      border: "1px solid #ccc",
      width: "auto", // width'i auto yaparak esneklik sağladık
      minWidth: "150px",
      borderRadius: '5px',
      marginRight: '10px',
    }}
  />
  <h2
  className="mt-2"
    style={{
  
      marginRight: '20px',
      flexShrink: 0,
      whiteSpace: 'nowrap',
    }}
  >
    Teklif Listesi
  </h2>
  <button
     onClick={handleAddForm}
    style={{
      padding: "10px",
      background: "green",
      color: "white",
      border: "none",
      cursor: "pointer",
      borderRadius: "10px",
      minWidth: "120px",
    }}
  >
    Yeni Teklif Oluştur
  </button>
</div>
<div className="table-responsive mt-3">
<table className="table table-striped table-bordered mt-3">
        <thead>
          <tr>
          
            <th style={{width:'18%'}}>Firma</th>
            <th style={{width:'7%'}}>Proje</th>
            <th>İlgili</th>
            <th>Temsilci</th>
            <th>Genel Toplam</th>
            <th>Durum</th>
            <th>Oluşturma Tarihi</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {teklifler
            .filter((t) => normalizeName(t.firma_adi).includes(normalizeName(searchTerm)))
            .map((t) => (
            <tr key={t.id}>

              <td>{t.firma_adi}</td>
              <td>{t.proje_ismi}</td>
              <td>{t.ilgili}</td>
              <td>{t.temsilci}</td>
              <td>{t.genel_toplam} ₺</td>
              <td>{t.durum}</td>
              <td>{new Date(t.created_at).toLocaleDateString("tr-TR")}</td>
              <td>
              <div className="d-flex flex-wrap gap-2 align-items-center">
              <button
                  className="btn btn-sm btn-danger"
                  onClick={() => openSozlesmeModal(t)}
                  disabled={loadingSozlesmeId === t.id}
                  title="Sözleşme Oluştur"
                >
                  <i className="fa-solid fa-file-signature me-1"></i>
                  Sözleşme Oluştur
                </button>
              <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => handleTeklifDuzenle(t.id)}
                >
                Teklifi Düzenle
                <CiEdit className="icon" size="22px" />
                </button>

                <button
  className={`btn btn-sm ${
    t.durum === "Kiralama Yapıldı"
      ? "btn-secondary"
      : "btn-warning"
  }`}
  onClick={() => handleDetay(t.id)}
  disabled={t.durum === "Kiralama Yapıldı"}
>
  {t.durum === "Kiralama Yapıldı"
    ? "Kiralama Yapıldı"
    : "Kiralama Yap"}
</button>
                <button
        className="btn bt-sm"
        onClick={() => handleDelete(t.id)}
        title="Pasif Yap"
      >
       <MdDelete className="icon" color="red" size="22px" />
      </button>
              </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      {/* 📌 Teklif Detayı */}
      {secilenTeklif && (
        <div className="card mt-4">
          <div className="card-header">
            <h5>Teklif Detayı (ID: {secilenTeklif.id})</h5>
          </div>
          <div className="card-body">
            <p><strong>Firma:</strong> {secilenTeklif.firma_adi}</p>
            <p><strong>Proje:</strong> {secilenTeklif.proje_ismi}</p>
            <p><strong>İlgili:</strong> {secilenTeklif.ilgili}</p>
            <p><strong>Temsilci:</strong> {secilenTeklif.temsilci}</p>
            <p><strong>Ara Toplam:</strong> {secilenTeklif.ara_toplam} ₺</p>
            <p><strong>KDV (%{secilenTeklif.kdv_orani}):</strong> {secilenTeklif.kdv_tutar} ₺</p>
            <p><strong>Genel Toplam:</strong> {secilenTeklif.genel_toplam} ₺</p>
            <p><strong>Açıklama:</strong> {secilenTeklif.aciklama}</p>

            <h6 className="mt-3">Ürünler</h6>
            <table className="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>Ürün</th>
                  <th>Adet</th>
                  <th>Birim Fiyatı</th>
                  <th>Toplam</th>
                </tr>
              </thead>
              <tbody>
                {secilenTeklif.urunler.map((u) => (
                  <tr key={u.id}>
                    <td>{u.urun_adi}</td>
                    <td>{u.adet}</td>
                    <td>{formatBirimFiyat(u.birim_fiyati)}</td>
                    <td>{formatBirimFiyat(u.toplam)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {loading && <p className="mt-3">Yükleniyor...</p>}
    



</>
      ) : page == 2 ?(
        <>        <button
        className="btn btn-outline-secondary mb-3"
        onClick={() => navigate("/home")}
        style={{  left: "20px", top: "20px" }}
      >
        <CiSquareChevLeft /> Geri Dön
      </button>

  
      <div className="row g-3 justify-content-center">
        <div className="col-12 col-md-2">
          <label className="form-label">Firma Seç:</label>
          <SearchableSelect
            options={firms.map((f) => ({ value: f.id, label: f.name }))}
            value={selectedFirm}
            placeholder="Firma ara veya seç..."
            addNewLabel="Yeni Firma Ekle"
            onAddNew={openFirmaModal}
            onChange={(option) => {
              const firm = firms.find((f) => f.id === option?.value);
              setSelectedFirm(option?.value ?? "");
              setSelectedFirmLabel(firm?.name || "");
              setSelectedFirmİlgili(firm?.ilgili_kisi || "");
            }}
          />
        </div>
        <div className="col-12 col-md-2">
  <label className="form-label fw-bold">Teklif Türü:</label>
  <select
    className="form-select"
    value={selectedTeklifTuru}
    onChange={(e) => setSelectedTeklifTuru(e.target.value)}
  >
    <option value="">Seçiniz</option>
    <option value="asma">Asma İskele</option>
    <option value="cephe">Cephe Platformu</option>
  </select>
</div>
        <div className="col-12 col-md-2">
          <label className="form-label">Proje:</label>
          <input
            placeholder="Proje İsmi..."
            type="text"
            className="form-control"
            value={projename || ""}
            onChange={(e) => setProjeName(e.target.value)}
          />
        </div>

        <div className="col-12 col-md-2">
          <label className="form-label">Teklif Tarihi:</label>
          <input
            type="date"
            className="form-control"
            value={baslangicTarihi}
            onChange={(e) => setBaslangicTarihi(e.target.value)}
          />
        </div>

        <div className="col-12 col-md-4">
  <label className="form-label">Açıklama</label>
  <textarea
    className="form-control"
    rows="3"
    value={aciklama}
    onChange={(e) => setAciklama(e.target.value)}
    onKeyDown={(e) => {
      if (e.key === "Enter") {
        e.preventDefault(); // Yeni satıra geçerken varsayılan davranışı engelle
        const cursorPos = e.target.selectionStart;
        const textBefore = aciklama.substring(0, cursorPos);
        const textAfter = aciklama.substring(cursorPos);
        const updatedText = `${textBefore}\n• ${textAfter}`;
        setAciklama(updatedText);

        // Cursor'u yeni eklenen madde işaretinden sonra konumlandır
        setTimeout(() => {
          e.target.selectionStart = e.target.selectionEnd = cursorPos + 3;
        }, 0);
      }
    }}
    placeholder={`• Dikey ve yatay taşıma kiracıya aittir.\n• Periyodik muayene, söküm ve dönüş nakliyesi opsiyoneldir.`}
  />
</div>
      </div>

      {/* Ürün Ekleme Alanı */}
      <div className="row g-2 mt-3">
        <div className="col-12 col-md-2">
          <label className="form-label">Ürün/Hizmet</label>
          <SearchableSelect
            options={urunler.map((u) => ({ value: u.id, label: u.adi, cinsi_id: u.cinsi_id }))}
            value={selectedProduct?.value || ""}
            placeholder="Ürün ara veya seç..."
            addNewLabel="Yeni Ürün Ekle"
            onAddNew={openUrunModal}
            onChange={(option) => {
              if (option) {
                setSelectedProduct({
                  value: option.value,
                  label: option.label,
                  cinsi_id: option.cinsi_id,
                });
              } else {
                setSelectedProduct(null);
              }
            }}
          />
        </div>

        <div className="col-6 col-md-1">
          <label className="form-label">Adet</label>
          <input
            className="form-control"
            type="number"
            placeholder="Adet"
            value={quantity || ""}
            onChange={(e) => setQuantity(Number(e.target.value))}
          />
        </div>

        <div className="col-6 col-md-2">
          <label className="form-label">Fiyat (Adet)</label>
          <input
            className="form-control"
            type="number"
            placeholder="Birim Fiyat"
            value={unitPrice || ""}
            onChange={(e) => setUnitPrice(Number(e.target.value))}
            min="1"
          />
        </div>

        <div className="col-6 col-md-1">
          <label className="form-label">Birim</label>
          <select
            className="form-select"
            value={birim.value}
            onChange={onChangeBirim}
          >
            {birimler.map((b) => (
              <option key={b.value} value={b.value}>
                {b.label}
              </option>
            ))}
          </select>
        </div>

        <div className="col-6 col-md-2">
          <label className="form-label">Tutar</label>
          <input
            disabled
            className="form-control"
            type="number"
            value={quantity * unitPrice}
            readOnly
            placeholder="Toplam"
          />
        </div>

        {/* <div className="col-12 col-md-3">
          <label className="form-label">Açıklama</label>
          <input
            className="form-control"
            type="text"
            placeholder="..."
            value={aciklama || ""}
            onChange={(e) => setAciklama(e.target.value)}
          />
        </div> */}

        <div className="col-12 col-md-1 d-flex align-items-end">
          <button
            className="btn btn-success w-100"
            onClick={handleAddProduct}
          >
       {isEditProduct ? "Güncelle" : "Ürün Ekle"}
          </button>
        </div>
      </div>

      {/* Ürün Tablosu */}
      <div className="table-responsive mt-3">
        
        <table className="table table-bordered  ">
          <thead className="table">
            <tr>
              <th style={{ width: "36px" }}></th>
              <th>Ürün</th>
              <th>Adet</th>
              <th>Birim Fiyat</th>
              <th>Toplam</th>
              {/* <th>Açıklama</th> */}

            </tr>
          </thead>
          <tbody>
            {productList.map((p, i) => (
              <tr
                key={i}
                draggable
                onDragStart={handleProductDragStart(i)}
                onDragOver={handleProductDragOver(i)}
                onDrop={handleProductDrop(i)}
                onDragEnd={handleProductDragEnd}
                style={{
                  opacity: dragProductIndex === i ? 0.4 : 1,
                  borderTop: dragOverProductIndex === i && dragProductIndex !== i ? "2px solid #198754" : undefined,
                  cursor: "grab",
                }}
              >
                <td className="text-center" style={{ cursor: "grab" }} title="Sürükleyerek sırala">
                  <MdDragIndicator className="icon" size="20px" color="#888" />
                </td>
                <td>{p.urun_adi}
              <button
              className="btn btn-sm"
              onClick={(e) => {
                e.stopPropagation();
                handleEditProduct(p, i); // burada i = productList'teki index
              }}
              >
              <CiEdit className="icon" size="22px" />
              </button>
              <button
              className="btn btn-sm"
              onClick={() => handleDeleteList(i)}
              >
              <CiTrash className="icon" size="22px" />
              </button>

                </td>

                <td>{p.adet}</td>
                <td>{formatBirimFiyat(p.birim_fiyati)}</td>
                <td>
                  {Number(p.toplam) ? (
                    <>
                      {p.toplam}{" "}
                      <span style={{ fontSize: "16px", color: "gray" }}>
                        {p.birim}
                      </span>
                    </>
                  ) : (
                    "-"
                  )}
                </td>
                {/* <td>{p.aciklama}</td> */}

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Özet Bilgiler */}
      <div className="mt-3 row justify-content-end">
        <div className="col-12 col-md-4">
          <div className="mb-2 d-flex justify-content-between align-items-center">
            <label><strong>Ara Toplam:</strong></label>
            <div className="d-flex align-items-center">
              <input
                type="number"
                className="form-control form-control-sm"
                style={{ width: "110px" }}
                value={araToplam}
                onChange={(e) => setAraToplamOverride(Number(e.target.value))}
              />
              <span className="ms-1">{birim.label}</span>
            </div>
          </div>
          <div className="mb-2 d-flex justify-content-between align-items-center">
            <label><strong>KDV Oranı (%):</strong></label>
            <input
              type="number"
              className="form-control form-control-sm"
              style={{ width: "80px" }}
              value={kdvOrani}
              onChange={(e) => setKdvOrani(Number(e.target.value))}
              min="0"
            />
          </div>
          <div className="mb-2 d-flex justify-content-between">
            <span><strong>KDV Tutarı:</strong></span>
            <span>{kdvTutar.toFixed(2)} {birim.label}</span>
          </div>
          <div className="mb-3 d-flex justify-content-between">
            <span><strong>Genel Toplam:</strong></span>
            <span>{genelToplam.toFixed(2)} {birim.label}</span>
          </div>
          <button className="btn btn-secondary w-100" onClick={handlePdf} disabled={loading}>
  {loading ? (
    <>
      <span className="spinner-border spinner-border-sm me-2"></span>
      Oluşturuluyor...
    </>
  ) : (
    "Teklif Formu Oluştur"
  )}
</button>

<button className="btn mt-2 btn-success w-100" onClick={handleSave} disabled={loading}>
    Teklifi Kaydet
  </button>
        </div>
      </div>
      </>

      ):(null)}

      {showFirmaModal && createPortal(
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{
            position: "fixed",
            inset: 0,
            width: "100vw",
            height: "100vh",
            overflowY: "auto",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 2000,
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Yeni Firma Ekle</h5>
                <button type="button" className="btn-close" onClick={() => setShowFirmaModal(false)}></button>
              </div>
              <div className="modal-body">
                <label className="form-label">Firma Adı:</label>
                <input
                  type="text"
                  className="form-control mb-2"
                  value={yeniFirma.name}
                  onChange={(e) => setYeniFirma({ ...yeniFirma, name: e.target.value })}
                />
                <label className="form-label">İlgili Kişi:</label>
                <input
                  type="text"
                  className="form-control mb-2"
                  value={yeniFirma.ilgili_kisi}
                  onChange={(e) => setYeniFirma({ ...yeniFirma, ilgili_kisi: e.target.value })}
                />
                <label className="form-label">Telefon:</label>
                <input
                  type="tel"
                  className="form-control mb-2"
                  value={yeniFirma.phone}
                  onChange={(e) => setYeniFirma({ ...yeniFirma, phone: e.target.value })}
                />
                <label className="form-label">E-Posta:</label>
                <input
                  type="email"
                  className="form-control mb-2"
                  placeholder="(Türkçe karakter kullanmayınız)"
                  value={yeniFirma.email}
                  onChange={(e) => {
                    const cleanValue = e.target.value.replace(/[ığüşöçİĞÜŞÖÇ]/g, "");
                    setYeniFirma({ ...yeniFirma, email: cleanValue });
                  }}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowFirmaModal(false)} disabled={savingFirma}>
                  Vazgeç
                </button>
                <button className="btn btn-success" onClick={handleSaveYeniFirma} disabled={savingFirma}>
                  {savingFirma ? "Kaydediliyor..." : "Kaydet"}
                </button>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}

      {showUrunModal && createPortal(
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{
            position: "fixed",
            inset: 0,
            width: "100vw",
            height: "100vh",
            overflowY: "auto",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 2000,
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Yeni Ürün Ekle</h5>
                <button type="button" className="btn-close" onClick={() => setShowUrunModal(false)}></button>
              </div>
              <div className="modal-body">
                <label className="form-label">Ürün Adı:</label>
                <input
                  type="text"
                  className="form-control mb-2"
                  value={yeniUrun.adi}
                  onChange={(e) => setYeniUrun({ ...yeniUrun, adi: e.target.value })}
                />
                <label className="form-label">Cinsi:</label>
                <select
                  className="form-select mb-2"
                  value={yeniUrun.cinsi_id}
                  onChange={(e) => setYeniUrun({ ...yeniUrun, cinsi_id: e.target.value })}
                >
                  <option value="">Seçiniz...</option>
                  {urunCinsleri.map((cins) => (
                    <option key={cins.id} value={cins.id}>
                      {cins.cins_adi}
                    </option>
                  ))}
                </select>
                <label className="form-label">Stok Adedi:</label>
                <input
                  type="number"
                  className="form-control mb-2"
                  min="0"
                  value={yeniUrun.stok_adet}
                  onChange={(e) => setYeniUrun({ ...yeniUrun, stok_adet: e.target.value })}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowUrunModal(false)} disabled={savingUrun}>
                  Vazgeç
                </button>
                <button className="btn btn-success" onClick={handleSaveYeniUrun} disabled={savingUrun}>
                  {savingUrun ? "Kaydediliyor..." : "Kaydet"}
                </button>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}

      {showSozlesmeModal && createPortal(
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{
            position: "fixed",
            inset: 0,
            width: "100vw",
            height: "100vh",
            overflowY: "auto",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 2000,
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Müşteri Kaşe Bilgileri</h5>
                <button type="button" className="btn-close" onClick={() => setShowSozlesmeModal(false)}></button>
              </div>
              <div className="modal-body">
                <p className="text-muted" style={{ fontSize: "13px" }}>
                  Bu bilgiler sözleşmedeki kiracı kaşe alanına yazılacaktır. Boş bırakırsanız firma kaydındaki bilgiler kullanılır.
                </p>
                <label className="form-label">Firma Ünvanı:</label>
                <input
                  type="text"
                  className="form-control mb-2"
                  value={kaseForm.firmaAdi}
                  onChange={(e) => setKaseForm({ ...kaseForm, firmaAdi: e.target.value })}
                />
                <label className="form-label">Adres:</label>
                <textarea
                  className="form-control mb-2"
                  rows="2"
                  value={kaseForm.adres}
                  onChange={(e) => setKaseForm({ ...kaseForm, adres: e.target.value })}
                />
                <label className="form-label">Vergi Dairesi:</label>
                <input
                  type="text"
                  className="form-control mb-2"
                  value={kaseForm.vergiDairesi}
                  onChange={(e) => setKaseForm({ ...kaseForm, vergiDairesi: e.target.value })}
                />
                <label className="form-label">Vergi No:</label>
                <input
                  type="text"
                  className="form-control mb-2"
                  value={kaseForm.vergiNo}
                  onChange={(e) => setKaseForm({ ...kaseForm, vergiNo: e.target.value })}
                />

                <div className="mt-3">
                  <label className="form-label">Kaşe Önizleme:</label>
                  <div
                    style={{
                      border: "1px dashed #999",
                      borderRadius: "4px",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    <div style={{ fontWeight: 800, textTransform: "uppercase", fontSize: "14px" }}>
                      {kaseForm.firmaAdi || sozlesmeTeklif?.firma_adi || "FİRMA ÜNVANI"}
                    </div>
                    {kaseForm.adres && (
                      <div style={{ fontSize: "11px", color: "#333", marginTop: "2px" }}>{kaseForm.adres}</div>
                    )}
                    {(kaseForm.vergiDairesi || kaseForm.vergiNo) && (
                      <div style={{ fontSize: "11px", color: "#333", marginTop: "2px" }}>
                        {[kaseForm.vergiDairesi && `V.D: ${kaseForm.vergiDairesi}`, kaseForm.vergiNo && `V.No: ${kaseForm.vergiNo}`]
                          .filter(Boolean)
                          .join(" - ")}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowSozlesmeModal(false)}>
                  Vazgeç
                </button>
                <button
                  className="btn btn-danger"
                  onClick={handleSozlesmeModalSubmit}
                  disabled={loadingSozlesmeId === sozlesmeTeklif?.id}
                >
                  {loadingSozlesmeId === sozlesmeTeklif?.id ? "Oluşturuluyor..." : "Sözleşme Oluştur"}
                </button>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}

    </div>


  );
};


export default TeklifFormuOlustur;